import { render, staticRenderFns } from "./ApuracaoPendentesTabela.vue?vue&type=template&id=194015f5&lang=html&"
import script from "./ApuracaoPendentesTabela.vue?vue&type=script&lang=js&"
export * from "./ApuracaoPendentesTabela.vue?vue&type=script&lang=js&"
import style0 from "../../../../../../shared-components/generico/TabelaGenerica.css?vue&type=style&index=0&lang=css&"
import style1 from "../../../../../../shared-components/generico/Pagination.css?vue&type=style&index=1&lang=css&"
import style2 from "../../../../../../shared-components/generico/TabelaSizing.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/ApuracaoPendentesTabela.vue
// module id = 1275
// module chunks = 28